export enum StatusCodeEnum {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  UNPROCESSABLE_CONTENT = 422,
  LOCKED = 423,
  SERVICE_UNAVAILABLE = 503,
}
